import useTranslation from '../../localization/i18n.context';
import { CloseWebviewEvent } from '../../sdk/close.webview.event';
import LandingPageScreen from '../../components/shared/LandingPageScreen/LandingPageScreen';
import { CardType, getCardAssetURL } from '../../clients/card.backgrounds';
export default function InvitationLandingPage({ organization }) {
  const { t, getOrganization } = useTranslation();
  const organizationName = getOrganization(organization);

  console.log('card landings test with organization equal to: ', organization);
  return (
    <LandingPageScreen
      onCloseClick={() => CloseWebviewEvent.closedByUser()}
      image={getCardAssetURL(
        organization?.toUpperCase(),
        CardType.LANDING_PAGE,
      )}
      title={t('Empower yourself with {card name} prepaid card', {
        '{card name}': organizationName,
      })}
      subtitle={t(
        'Use your card for all your purchases. See your transactions in-app.',
      )}
      organization={organization}
    />
  );
}
